import app from 'app';

import swap from './product/swap';
import variantSelector from './product/variant-selector';
import item from './wishlist/item';
import main from './wishlist/main';
import shareUrl from './wishlist/share-url';

app.add({
  wishlist: main,
  'wishlist-item': item,
  'wishlist-share-url': shareUrl,

  // Product components
  'product-variant-selector': variantSelector,
  'product-swap': swap,
});
